import React, { forwardRef } from 'react';

import DatePicker, { registerLocale, setDefaultLocale }  from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from 'date-fns/locale/es';
import { Tooltip } from '../utils/Tooltip';
registerLocale('es', es)

export const DatePickerDoble = ({
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    styles,
    classNameInput,
    esDisabled=false,

}) => {
    const DateInput = forwardRef(({ value, onClick }, ref) => (
        <input
            onClick={onClick}
            ref={ref}
            className={`${classNameInput ? classNameInput : ''} text-center text-white h-[30px]
            rounded px-2 w-[90px] bg-zinc-800 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500`}
            defaultValue={value}
            style={styles}
            readOnly
        />
    ));
    const cambioFechaInicio = (date) => {
        setStartDate(date);
        if (endDate && date && date > endDate) {
            setEndDate(date); // Asegura que la fecha fin sea igual o mayor a la fecha inicio
        }
    };

    // Maneja el cambio de fecha de fin
    const cambioFechaFin = (date) => {
        setEndDate(date)
        if (startDate && date && date < startDate) {
            setStartDate(date); // Asegura que la fecha inicio sea igual o menor a la fecha fin
        }
    } 

    return (
        <section className=' flex gap-2 w-[240px] '>
            <section className='flex gap-1.5 items-center w-[130px]'>
                <i
                    className='far fa-calendar-alt'
                    data-tip={'start-date'}
                    data-for={'start-date'}
                ></i>
                <Tooltip id={'start-date'}>Fecha inicio</Tooltip>
                <DatePicker
                    // showYearDropdown
                    // showMonthDropdown
                    locale="es"
                    selected={startDate}
                    onChange={cambioFechaInicio}
                    customInput={<DateInput/>}
                    dateFormat="dd/MM/yyyy"
                    icon="fa fa-calendar"
                    maxDate={endDate}
                    popperClassName="custom-popper-datepicker"
                    popperPlacement="bottom"
                ></DatePicker>
            </section>
            <section className='flex w-[130px] gap-2 items-center'>
                <i
                    className='far fa-calendar-alt'
                    data-tip={'end-date'}
                    data-for={'end-date'}
                ></i>
                <Tooltip id={'end-date'}>Fecha fin</Tooltip>
                <DatePicker
                    locale="es"
                    selected={endDate}
                    onChange={cambioFechaFin}
                    customInput={<DateInput/>}
                    dateFormat="dd/MM/yyyy"
                    minDate={startDate}
                    maxDate={new Date()}
                    popperClassName="custom-popper-datepicker"
                    popperPlacement="bottom"
                ></DatePicker>
            </section>
        </section>

    )
}